import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FilterListIcon from "@mui/icons-material/FilterList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Divider from "@mui/material/Divider";
import { useStore } from "csi/state/hooks";
import { Checkbox, CheckedMenuItem, FlexRow, IconButton, MenuItemWithIcon, MoreHorizMenu, MultiSelect, Text } from "designSystem/index";
import { blue } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React from "react";
import css from "./SnapshotListFilters.module.css";

const SnapshotListFilters = observer(() => {
	const { threeDStore } = useStore();
	const { 
		allVisibleSnapshots,
		allVisibleItemSelected,
		canDeleteImages,
		deleteSnapshots,
		onSelectAll,
		snapshotFiltersOpen,
		toggleSnapshotFilters,
	} = threeDStore.snapshotsStore;

	return (
		<>
			<FlexRow
				justifyContent="space-between"
				p={3}
				paddingBottom={2}
				paddingTop={2}
			>
				<Checkbox
					checked={allVisibleItemSelected}
					disabled={allVisibleSnapshots.length === 0}
					labelProps={{
						label: "Select All",
						componentsProps: {
							typography: {
								color: `${blue[600]} !important`,
							},
						},
					}}
					onChange={onSelectAll}
				/>
				<FlexRow gap={2}>
					{
						canDeleteImages && (
							<IconButton
								color="inherit"
								onClick={deleteSnapshots}
							>
								<DeleteForeverIcon />
							</IconButton>
						)
					}
					<IconButton
						className={snapshotFiltersOpen ? css.active : ""}
						color="inherit"
						onClick={toggleSnapshotFilters}
					>
						<FilterListIcon />
					</IconButton>
				</FlexRow>
			</FlexRow>
			{
				snapshotFiltersOpen && (
					<Filters />
				)
			}
		</>
	);
});

const Filters = observer(() => {
	const { threeDStore } = useStore();
	const { 
		groupByGenerationType,
		hideTags,
		toggleHideTags,
		validatedSelectedFilters,
		setSelectedCameraPositionsFilter,
		setGroupByGenerationType,
		cameraPositionsFilterOptions,
		compareValuesOnDynamicFilterOptions,
	} = threeDStore.snapshotsStore;
	
	const { modelVariants } = threeDStore.canvasStore;
	
	return (
		<FlexRow 
			gap={1}
			justifyContent="space-between"
			p={2}
		>
			<FlexRow
				alignItems="center"
				flexGrow={1}
				gap={2}
			>
				<Text res="3DFilter" />
				<MultiSelect
					isOptionEqualToValue={compareValuesOnDynamicFilterOptions}
					limitTags={2}
					noChips
					onChange={setSelectedCameraPositionsFilter}
					options={cameraPositionsFilterOptions}
					placeHolderRes="3DSelectCameraPositions"
					sx={{
						width: "100%",
					}}
					value={validatedSelectedFilters}
				/>
			</FlexRow>
			<MoreHorizMenu>
				<CheckedMenuItem
					checked={groupByGenerationType}
					onClick={() => setGroupByGenerationType(true)}
					res="3DGroupByGenerationType"
				/>
				<CheckedMenuItem
					checked={!groupByGenerationType}
					disabled={!modelVariants}
					onClick={() => setGroupByGenerationType(false)}
					res="3DGroupByVariant"
				/>
				<Divider />
				<MenuItemWithIcon
					onClick={toggleHideTags}
					res={hideTags ? "3DShowTags" : "3DHideTags"}
				>
					{hideTags ?
						<VisibilityIcon color="action" style={{ fontSize: 16 }} />
						:
						<VisibilityOffIcon color="action" style={{ fontSize: 16 }} />
					}
				</MenuItemWithIcon>
			</MoreHorizMenu>
		</FlexRow>
	);
});


export default SnapshotListFilters;